export enum AgentType {
    AGENT = 'Field Agent',
    SUPERVISOR = 'Supervisor',
}

export enum HGSAgentType {
    AGENT = 'Field Agent',
    SUPERVISOR = 'Supervisor',
    SUPERUSER = 'Super User',
}

export enum AgentLocationType {
    L = 'Work Site',
    C = 'Call Center',
}